// Tolstoy
(() => {
if (window.__coolibarTolstoyOverridesLoaded) return;
window.__coolibarTolstoyOverridesLoaded = true;

const settings = {
launcherSize: 50,
launcherLeft: 20,
launcherBottom: 70,
panelLeft: 20,
panelBottom: 24,
zIndexClosed: 100,
zIndexOpen: 2147483000,
};

const desktopQuery = window.matchMedia('(min-width: 768px)');
const observedRoots = new WeakSet();
let updateQueued = false;

const setImportant = (element, property, value) => {
element.style.setProperty(property, value, 'important');
};

const queueUpdate = () => {
if (updateQueued) return;
updateQueued = true;

requestAnimationFrame(() => {
updateQueued = false;
applyOverrides();
});
};

const watchShadowRoot = (root) => {
if (observedRoots.has(root)) return;

observedRoots.add(root);

new MutationObserver(queueUpdate).observe(root, {
childList: true,
subtree: true,
});
};

const updateLauncher = (root) => {
const button = root.querySelector(
'button[aria-label="Open chat assistant"]'
);

if (!button) return;

const wrapper = button.closest('.fixed') || button.parentElement;

setImportant(button, 'width', `${settings.launcherSize}px`);
setImportant(button, 'height', `${settings.launcherSize}px`);

if (wrapper) {
setImportant(wrapper, 'left', `${settings.launcherLeft}px`);
setImportant(wrapper, 'right', 'auto');
setImportant(wrapper, 'top', 'auto');
setImportant(wrapper, 'bottom', `${settings.launcherBottom}px`);
}
};

const findFixedAncestor = (element) => {
let current = element;

while (current) {
if (getComputedStyle(current).position === 'fixed') {
return current;
}

current = current.parentElement;
}

return null;
};

const updateChatPanel = (root) => {
const dialog = root.querySelector(
'[role="dialog"][aria-label="Chat assistant"]'
);

if (!dialog) return;

const panel = findFixedAncestor(dialog);
if (!panel) return;

// Prevent this workaround from changing centered or full-screen modals.
if (!String(panel.className).includes('md:right-6')) return;

if (desktopQuery.matches) {
setImportant(panel, 'left', `${settings.panelLeft}px`);
setImportant(panel, 'right', 'auto');
setImportant(panel, 'bottom', `${settings.panelBottom}px`);
} else {
// Keep the normal full-screen mobile layout.
panel.style.removeProperty('left');
panel.style.removeProperty('right');
panel.style.removeProperty('bottom');
}
};

function applyOverrides() {
if (!document.body) return;

const hosts = new Set([
document.getElementById('chat-bubble-root'),
...document.body.children,
]);

for (const host of hosts) {
const root = host?.shadowRoot;
if (!root) continue;

const isTolstoy = root.querySelector(
'button[aria-label="Open chat assistant"], [role="dialog"][aria-label="Chat assistant"]'
);

if (isTolstoy) {
const isOpen = root.querySelector(
'[role="dialog"][aria-label="Chat assistant"]'
);

setImportant(
host,
'z-index',
String(isOpen ? settings.zIndexOpen : settings.zIndexClosed)
);
}

watchShadowRoot(root);
updateLauncher(root);
updateChatPanel(root);
}
}

const start = () => {
new MutationObserver(queueUpdate).observe(document.body, {
childList: true,
});

desktopQuery.addEventListener?.('change', queueUpdate);

applyOverrides();

// Handles Shadow Roots that attach after their host element is added.
window.setInterval(applyOverrides, 2000);
};

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
start();
}
})();